<template>
  <div id="app">
    <NavBar></NavBar>
    <!-- <div id="nav">
      <router-link to="/">Home</router-link> | 
      <router-link to="/about">About</router-link>
    </div> -->
    <router-view/>
    <div id="bg" class="noselect">second undistinguished puzzle hunt</div>
  </div>
</template>

<script>
import NavBar from '@/components/NavBar.vue'

export default {
  components: {
    NavBar
  },
  created: function() {
    this.$store.commit('initAnswers')
  }
}
</script>


<style lang="scss">

@font-face {
    font-family: 'MyriadProCond';
    src: url("~@/assets/fonts/MyriadPro-Cond.otf") format("opentype");
}

@font-face {
    font-family: 'MyriadPro';
	src: url("~@/assets/fonts/MyriadPro-Regular.otf") format("opentype");
}
	
@font-face {
	font-family: 'MyriadProCond';
	font-weight: bold;
	src: url("~@/assets/fonts/MyriadPro-BoldCond.otf") format("opentype");
}

$color-bg: rgb(240, 240, 240);
$color-puzzle-bg: #d8d8d8;

$color-default: rgb(26, 14, 0);
$color-nav-bar: #999999;
$color-bold: rgb(118, 23, 173);
$color-link: rgb(27, 125, 152);

.flex {
	display: flex;
  flex-direction: row;
  flex-wrap:wrap;
	justify-content: space-around;
	/* width: 100%; */
}

#bg {	
  	font-family: MyriadProCond, Helvetica, Arial, sans-serif;

	// color: #101;
  color: #999;
	position:fixed;
	z-index: -100;
	bottom: 0;
	right: 2%;
	font-weight:300;
	font-size: 80pt;
	opacity:0.15;
}

hr {
  
height:1px; 
border:none; 
color:#555; 
background-color:#555;
// width:60%; 
text-align:center; 
margin: 0 auto;
}

body {		
	font-family: MyriadPro, Helvetica, Arial, sans-serif;
	color: $color-default;
	background: $color-bg;
	font-size: 28px;
}

b {
	color: $color-bold
}

:link, :visited { 
  color: $color-link; 
  text-decoration: none;
  font-weight: bold;
}

#puzzle-content, #puzzle-solution {

  background: $color-puzzle-bg;
  
  border-radius: 30px;
  position: relative;
  margin:auto;
  
  font-size: 18pt;
  padding: 15px;
  width: 80%;

  table {
    /* Remove spacing between table cells (from Normalize.css) */
    border-collapse: collapse;
    border-spacing: 0;
    empty-cells: show;
    border: 1px solid #919191;

    td,
    th {
        border-left: 1px solid #919191;/*  inner column border */
        border-bottom: 1px solid #919191;/*  inner column border */
        border-width: 0 0 1px 1px;
        font-size: inherit;
        margin: 0;
        overflow: visible; /*to make ths where the title is really long work*/
        padding: 0.5em 1em; /* cell padding */
    }

    thead {
        background-color: #e0e0e0;
        color: #000;
        text-align: left;
        vertical-align: bottom;
    }
  }
}

#nav-bar {
  font-weight: normal;

	display: flex;
	flex-direction: row;
	justify-content: space-between;
	width: 100%;
  font-family: MyriadProCond, Helvetica, Arial, sans-serif;

  #right {
    text-align: right;
  }
  
  li {
    list-style: none;
  }

  :link { color: $color-nav-bar; text-decoration: none; font-weight: normal}
  :visited { color: $color-nav-bar; text-decoration: none; font-weight: normal}
  .router-link-exact-active {
    color: $color-default;
    pointer-events: none;
    cursor: default;
  }
}


#app {
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  /* color: #2c3e50; */
  /* margin-top: 60px; */
}

.noselect {
	-webkit-touch-callout: none; /* iOS Safari */
	  -webkit-user-select: none; /* Safari */
	   -khtml-user-select: none; /* Konqueror HTML */
		 -moz-user-select: none; /* Firefox */
		  -ms-user-select: none; /* Internet Explorer/Edge */
			  user-select: none; /* Non-prefixed version, currently
									supported by Chrome and Opera */
  }
</style>
